A candidate process history item in a paginated list.
